import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex sx:flex-col justify-center items-center md:justify-start md:items-start gap-4 mt-8" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full md:w-1/2 p-3 rounded-md border border-gray-400 text-left\"><div class=\"text-[14px] font-bold\">Your followers</div><p class=\"text-xs leading-5\"> You have people following your book review comment profile. Check out followers list, and share your profile to friends to check out your reviews. </p><div class=\"mt-2 flex\"><button class=\"flex justify-center items-center rounded px-4 py-2 gap-2 bg-[#CBD5E0]\"><span class=\"text-[12px]\">View Followers</span><svg viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" data-v-ea893728=\"\" width=\"12\" height=\"12\"><path fill=\"currentColor\" d=\"M128 192h768v128H128V192zm0 256h512v128H128V448zm0 256h768v128H128V704zm576-352 192 160-192 128V352z\"></path></svg></button></div></div>", 1)
const _hoisted_3 = { class: "md:w-1/2 sx:w-full p-3 rounded-md border border-gray-400 text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-[14px] font-bold" }, "Reviews & Comments", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs leading-5" }, " Comment on books you've read by adding a review. Your review will be featured under our review section, and your followers will get to see them. ", -1)
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "space-y-2 mt-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("textarea", {
  placeholder: "Review",
  class: "w-full min-h-[150px] text-xs bg-transparent border border-gray-400 text-black outline-none p-2 rounded"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "w-full rounded-sm px-4 py-2 font-medium bg-boxColor text-white text-sm outline-none hover:shadow-typeBox",
  type: "submit"
}, " Comment ", -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "Book Title",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.book_title) = $event)),
            class: "w-full text-xs bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
          }, null, 512), [
            [_vModelText, _ctx.book_title]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.review) = $event)),
            class: "w-full text-xs bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
          }, null, 512), [
            [_vModelText, _ctx.review]
          ]),
          _hoisted_8,
          _hoisted_9
        ])
      ])
    ])
  ]))
}